<template>
    <div id="login-page" v-bind:style="{ background: color }">
        <loader v-if="loading"></loader>
        <div class="content" v-if="!loading">
            <img :src="image" />
            <p v-if="hasPlace">
                <strong> Valorizamos sua opinião! </strong> <br />
                Preencha o formulário e ganhe um bônus.
            </p>
            <p v-if="!hasPlace">
                <strong> Acompanhe os seus cupons! </strong> <br />
                Acesse e confira os descontos já adquiridos.
            </p>
            <form class="form-login" @submit.prevent="start">
                <template v-if="!usesActivatorFlow && hasPlace">
                    <span class="error" v-if="erro">{{ erro }}</span>
                </template>
            </form>
            <!--  <span class="fa fa-google"> </span>
        <span v-if="loggingIn" class="fa fa-spin fa-spinner"></span>
        Começar com Gmail
      </button> -->
        </div>
    </div>
</template>
<script>
import keviApi from "./../keviApi";

export default {
    name: "login",
    props: {
        client: Object,
    },
    data: function () {
        return {
            loading: true,
            loggingIn: false,
            image: "images/kevi.png",
            color: "#ddd",
            hasPlace: false,
            cpf: null,
            password: null,
            erro: false,
            forgotPasswordError: "",
            forgotPasswordSuccess: "",
            usesActivatorFlow: null,
            linkCode: null,
            linkCodeValid: null,
        };
    },
    mounted: function () {
        document.getElementsByTagName("title")[0].innerText =
            "Kevi, Sua Opinião Vale Descontos";

        if (!this.$route.query.place) {
            this.color = "#0f2f67";
            this.loading = false;
        } else {
            this.hasPlace = true;
            this.linkCode = this.$route.query.code
                ? this.$route.query.code
                : null;
            var options = keviApi.getOptions(
                "place/" + this.$route.query.place + "/public-info",
            );
            this.$http(options).then(
                function (response) {
                    if (response.status === 200) {
                        if (!response.body.logo) {
                            response.body.logo = "images/kevi.png";
                        }
                        if (!response.body.color) {
                            response.body.color = "#0f2f67";
                        } else {
                            response.body.color = "#" + response.body.color;
                        }
                        this.image = response.body.logo;
                        this.color = response.body.color;
                        this.usesActivatorFlow = parseInt(
                            response.body["uses_activator_flow"],
                        );
                        this.$store.commit("setPlace", response.body);
                        if (!this.usesActivatorFlow) {
                            if (!this.linkCode) {
                                this.linkCodeValid = false;
                                this.erro = "Link inválido.";
                                this.loading = false;
                            } else {
                                this.authenticateWithLinkCode(this.linkCode);
                            }
                        } else {
                            this.loading = false;
                            this.$emit("found-place", response.body);
                        }
                    }
                },
                function () {
                    this.loading = false;
                },
            );
        }
    },
    methods: {
        foundClient: function (data) {
            this.$emit("found-client", data);
        },
        authenticateWithLinkCode: function (code) {
            var options = keviApi.getOptions(
                "client/get-client-by-link-code",
                "GET",
                { code: code, place: this.$route.query.place },
            );
            this.$http(options).then(
                function (response) {
                    this.$store.commit("setLinkCode", response.body.code);
                    let toUrl = "form/" + response.body.code.forms_id;
                    window.sessionStorage.setItem("login-redirect", toUrl);
                    this.$emit("found-client", response.body.client);
                },
                (response) => {
                    this.erro = "Link inválido";
                    if (response.body.message === "used-code") {
                        this.erro = "Link já utilizado";
                    }
                    this.loading = false;
                    this.linkCodeValid = false;
                },
            );
        },
        forgotMyPassword: function (data) {
            this.forgotPasswordError = "";
            this.forgotPasswordSuccess = "";
            if (this.cpf) {
                var options = keviApi.getOptions(
                    "client/send-reset-password-email",
                    "POST",
                    { cpf: this.cpf },
                );
                this.$http(options).then(
                    function (response) {
                        if (response.body.status === "success") {
                            this.forgotPasswordSuccess =
                                "Enviamos um e-mail para você com instruções sobre como resetar sua senha.";
                        } else {
                            this.forgotPasswordSuccess =
                                "Ocorreu um erro ao envia o e-mail para você, tente mais tarde.";
                        }
                    },
                    function (response) {
                        var error = "Ocorreu um erro.";
                        switch (response.body.message) {
                            case "invalid-cpf":
                                error = "O CPF informado é inválido.";
                                break;
                            case "not-found":
                                error =
                                    "Nenhum cliente encontrado com esse CPF.";
                                break;
                        }
                        this.forgotPasswordError = error;
                    },
                );
            } else {
                this.forgotPasswordError =
                    "Por favor preencha seu cpf e clique novamente.";
            }
        },
        redirect: function () {
            let toUrl = window.sessionStorage.getItem("login-redirect");
            this.$router.push(toUrl);
        },
        start: function () {
            if (this.validaCpf(this.cpf)) {
                var data = { cpf: this.cpf };
                if (!this.hasPlace) {
                    data.auth = 1;
                    data.password = this.password;
                }
                this.erro = false;
                this.loading = true;
                var options = keviApi.getOptions(
                    "client/get-client-by-cpf",
                    "GET",
                    data,
                );
                this.$http(options).then(
                    function (response) {
                        this.loading = false;
                        let toUrl = "/meus-cupons";
                        if (this.$route.query.place) {
                            toUrl = "enquete/" + this.$route.query.place;
                        }
                        window.sessionStorage.setItem("login-redirect", toUrl);
                        this.$emit("found-client", response.body.client);
                    },
                    function () {
                        this.erro = true;
                        this.loading = false;
                    },
                );
            } else {
                this.erro = true;
            }
        },
        validaCpf: function (cpf) {
            if (!cpf) {
                return false;
            }
            cpf = cpf.replace(/[^0-9]/gi, "");
            var numeros, digitos, soma, i, resultado, digitos_iguais;
            digitos_iguais = 1;
            if (cpf.length < 11) return false;
            for (i = 0; i < cpf.length - 1; i++) {
                if (cpf.charAt(i) != cpf.charAt(i + 1)) {
                    digitos_iguais = 0;
                    break;
                }
            }
            if (!digitos_iguais) {
                numeros = cpf.substring(0, 9);
                digitos = cpf.substring(9);
                soma = 0;
                for (i = 10; i > 1; i--) soma += numeros.charAt(10 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado != digitos.charAt(0)) return false;
                numeros = cpf.substring(0, 10);
                soma = 0;
                for (i = 11; i > 1; i--) soma += numeros.charAt(11 - i) * i;
                resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
                if (resultado != digitos.charAt(1)) return false;
                return true;
            } else {
                return false;
            }
        },
    },
    watch: {
        client: function () {
            if (this.client.id) {
                this.redirect();
            }
        },
    },
};
</script>
